import PropTypes from "prop-types"
import React from "react"

import {
  LaunchesComplete as LaunchesCompleteImage,
  NoBoatsLaunched as NoBoatsLaunchedImage,
  NoLaunchesScheduled as NoLaunchesScheduledImage,
  NoRecentReturns as NoRecentReturnsImage,
} from "./BlankStateImages"

const BlankStateCard = ({ image, heading, children }) => (
  <div className="card flex items-center justify-center">
    <div className="flex flex-col items-center justify-center px-8 py-36 text-center">
      <div className="mb-4">{image}</div>
      <span className="mb-4 text-lg font-bold">{heading}</span>
      {children}
    </div>
  </div>
)

BlankStateCard.propTypes = {
  image: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export const AllLaunchesComplete = ({ onNavigateToLaunched }) => (
  <BlankStateCard
    image={<LaunchesCompleteImage />}
    heading="All launches complete"
  >
    <span className="text-muted">
      Nice! Check the{" "}
      <span
        className="text-link cursor-pointer font-semibold text-blue-700"
        onClick={onNavigateToLaunched}
      >
        launched tab
      </span>{" "}
      to see what boats may need to be returned.
    </span>
  </BlankStateCard>
)

AllLaunchesComplete.propTypes = {
  onNavigateToLaunched: PropTypes.func.isRequired,
}

export const NoLaunchesScheduled = ({ onNavigateToSettings }) => (
  <BlankStateCard
    image={<NoLaunchesScheduledImage />}
    heading="No launches scheduled yet"
  >
    <span className="text-muted">
      Boaters can schedule launches through their Dockwa account. Adjust
      availability in your{" "}
      <span
        onClick={onNavigateToSettings}
        className="text-link cursor-pointer whitespace-nowrap font-semibold text-blue-700"
      >
        dry stack settings.
      </span>
    </span>
  </BlankStateCard>
)

NoLaunchesScheduled.propTypes = {
  onNavigateToSettings: PropTypes.func.isRequired,
}

export const NoBoatsLaunched = () => (
  <BlankStateCard image={<NoBoatsLaunchedImage />} heading="No boats out">
    <span className="text-muted">
      All previously launched boats have been marked returned.
    </span>
  </BlankStateCard>
)

export const NoRecentReturns = () => (
  <BlankStateCard image={<NoRecentReturnsImage />} heading="No recent returns">
    <span className="text-muted">
      This page shows boats returned in the past 48 hours.
    </span>
  </BlankStateCard>
)
